import { UPDATE_REFERENCE_PYRAMIDS, DELETE_REFERENCE_PYRAMID } from '../Mutations'
import { client } from '../../..'
import {
  ReferencePyramidInput,
  UpdateReferencedPyramidsMutation,
  UpdateReferencedPyramidsMutationVariables,
  Country,
  DeleteReferencedPyramidsMutation,
  DeleteReferencedPyramidsMutationVariables,
} from '../../../types'
import { REFERENCE_PYRAMIDS } from '../Queries'
import { GraphQLFormattedError } from 'graphql'

export default (): {
  updateReferencePyramids: (referencePyramidInput: ReferencePyramidInput) => Promise<UpdateReferencedPyramidsMutation | null | undefined>
  deleteReferencePyramid: (
    referencePyramidId: number,
    companyId: string,
    country: Country,
  ) => Promise<{
    data: DeleteReferencedPyramidsMutation | null | undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors: readonly GraphQLFormattedError<Record<string, any>>[] | undefined
  }>
} => {
  const updateReferencePyramids = async (
    referencePyramidInput: ReferencePyramidInput,
  ): Promise<UpdateReferencedPyramidsMutation | null | undefined> => {
    const variables = {
      referencePyramidInput: referencePyramidInput,
    }
    const { data } = await client.mutate<UpdateReferencedPyramidsMutation, UpdateReferencedPyramidsMutationVariables>({
      mutation: UPDATE_REFERENCE_PYRAMIDS,
      variables: variables,
      refetchQueries: [
        {
          query: REFERENCE_PYRAMIDS,
          variables: {
            companyId: referencePyramidInput.companyId,
            country: referencePyramidInput.country,
          },
        },
      ],
    })

    return data
  }

  const deleteReferencePyramid = async (
    referencePyramidId: number,
    companyId: string,
    country: Country,
  ): Promise<{
    data: DeleteReferencedPyramidsMutation | null | undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors: readonly GraphQLFormattedError<Record<string, any>>[] | undefined
  }> => {
    const variables = {
      referencePyramidId: referencePyramidId,
      companyId: companyId,
    }
    const { data, errors } = await client.mutate<DeleteReferencedPyramidsMutation, DeleteReferencedPyramidsMutationVariables>({
      mutation: DELETE_REFERENCE_PYRAMID,
      variables: variables,
      refetchQueries: [
        {
          query: REFERENCE_PYRAMIDS,
          variables: {
            companyId: companyId,
            country: country,
          },
        },
      ],
    })
    return { data, errors }
  }
  return { updateReferencePyramids, deleteReferencePyramid }
}
